enum Rarity {
  UR = "UR",
  SSR = "SSR",
  SR = "SR",
  R = "R",
  N = "N",
}

export default Rarity;
